import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useIntl, FormattedMessage } from 'react-intl';

import {
    Sizes,
    formatDollars,
    formatPercentage,
} from '@ratehub/base-ui';

import CardFeeSummaryContainer from './CardFeeSummaryContainer';


function CardFeeSummaryLowInterest({ cardInfo, ...otherProps }) {
    const intl = useIntl();

    return (
        <CardFeeSummaryContainer
            marginBottom={Sizes.SPACING.ONE_AND_A_HALF}
            {...otherProps}
        >
            <CardFeeSummaryContainer.Description className="row1">
                <FormattedMessage
                    id="ccrt.card.low-interest-annual-fee"
                    defaultMessage="Annual fee"
                />
            </CardFeeSummaryContainer.Description>
            <CardFeeSummaryContainer.Value className="row1">
                <output>
                    {formatDollars(cardInfo.annualFee, intl)}
                </output>
            </CardFeeSummaryContainer.Value>

            <CardFeeSummaryContainer.Separator className="row2" />

            <CardFeeSummaryContainer.Description className="row3">
                <FormattedMessage
                    id="ccrt.card.purchase-interest-rate-summary"
                    defaultMessage="Purchase interest rate"
                />
            </CardFeeSummaryContainer.Description>
            <CardFeeSummaryContainer.Value className="row3">
                <output>
                    {formatPercentage(cardInfo.purchaseInterest, intl)}
                </output>
            </CardFeeSummaryContainer.Value>

            <CardFeeSummaryContainer.Separator className="row4" />
        </CardFeeSummaryContainer>
    );
}

CardFeeSummaryLowInterest.propTypes = {
    cardInfo: PropTypes.shape({
        purchaseInterest: PropTypes.number,
        lowInterestMonthlyInterestFee: PropTypes.number.isRequired,
        annualFee: PropTypes.number.isRequired,
        lowInterestMonthlyBalance: PropTypes.number.isRequired,
    }).isRequired,
};


export default observer(CardFeeSummaryLowInterest);
